export const normalizePartsUsed = (parts) => {
  if (!parts) return [];
  if (Array.isArray(parts)) return parts.filter(Boolean);
  if (typeof parts === 'object') return [parts];
  return [];
};

export const formatPartsList = (parts) => {
  const normalized = normalizePartsUsed(parts);
  if (normalized.length === 0) return '';
  return normalized.map((part) => {
    const itemNumber = part.itemNumber || part.name || 'N/A';
    const description = part.description || part.name || '';
    const quantity = parseFloat(part.quantity) || 0;
    const cost = parseFloat(part.cost) || 0;
    const total = quantity * cost;
    return `${itemNumber}${description ? ` — ${description}` : ''} · Qty ${quantity.toFixed(2)} · $${cost.toFixed(2)} · $${total.toFixed(2)}`;
  }).join('\n');
};

export const collectServiceCallParts = (serviceCall) => {
  if (!serviceCall) return [];
  const parts = [...normalizePartsUsed(serviceCall.partsUsed)];
  (serviceCall.visits || []).forEach((visit) => {
    parts.push(...normalizePartsUsed(visit.partsUsed));
  });
  return parts;
};

/** Avoid rendering raw objects/arrays in JSX (React error #31). */
export const formatDisplayText = (value) => {
  if (value == null || value === '') return '—';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);

  if (Array.isArray(value)) {
    if (value.length > 0 && typeof value[0] === 'object' && (value[0]?.itemNumber != null || value[0]?.name != null)) {
      return formatPartsList(value) || '—';
    }
    return value.map((entry) => formatDisplayText(entry)).join('\n');
  }

  if (typeof value === 'object') {
    if (value.itemNumber != null || value.name != null || value.description != null) {
      return formatPartsList([value]) || '—';
    }
    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return '—';
    }
  }

  return String(value);
};

export const formatCopyText = (value) => {
  const text = formatDisplayText(value);
  return text === '—' ? '' : text;
};

/**
 * Structured clipboard package for entering Customers/Franklin work into QuickBooks.
 */
export const formatQuickBooksHandoff = (call, customerName = '') => {
  if (!call) return '';
  const parts = collectServiceCallParts(call);
  const partsBlock = formatPartsList(parts) || '(none)';
  const work = formatCopyText(call.workPerformed) || '(none)';
  const tech = call.technician
    ? `${call.technician.firstName || ''} ${call.technician.lastName || ''}`.trim()
    : '';
  const total = call.totalCost != null && call.totalCost !== ''
    ? `$${Number(call.totalCost).toFixed(2)}`
    : '';

  return [
    `Customer: ${customerName || '—'}`,
    `Invoice #: ${call.invoiceNumber || '(not set)'}`,
    `Completed: ${call.completedDate || '—'}`,
    tech ? `Technician: ${tech}` : null,
    total ? `Total cost: ${total}` : null,
    '',
    'Work performed:',
    work,
    '',
    'Parts:',
    partsBlock
  ].filter((line) => line != null).join('\n');
};
